import { selectors } from 'data'
import { PasswordStrengthType } from 'data/Form/Signup/types'
import { connect } from 'react-redux'

import PasswordStrength from './template'

export type PropsType = { score: PasswordStrengthType }

const mapStateToChangePasswordProps = (state) => ({
  score: selectors.changePassword.getPasswordStrength(state)
})

const mapStateToResetPasswordProps = (state) => ({
  score: selectors.forgotPassword.getPasswordStrength(state)
})

export const ChangePasswordStrength = connect(mapStateToChangePasswordProps)(PasswordStrength)

export const ResetPasswordStrength = connect(mapStateToResetPasswordProps)(PasswordStrength)
